const baseURL = process.env.REACT_APP_BASE_URL

export default {
    register: `${baseURL}/register`,
    login: `${baseURL}/login`,
    verify: `${baseURL}/verify?payload=`,
    resendVerify: `${baseURL}/verify/resend`,
    uploadImage:`${baseURL}/gallery/upload`,
    verifyCard:`${baseURL}/payment/verify/card`,
    makePickup:`${baseURL}/transaction-requests`,
    getCoupon:(couponId)=>`${baseURL}/coupons/${couponId}`,
    applyCoupon:`${baseURL}/coupons/apply`,
    profile: `${baseURL}/profile`,
    updateProfile: `${baseURL}/users`,
    transactionRequest: `${baseURL}/transaction-requests`,
    getPrice: `${baseURL}/pricing-plans`,
    getPricingPlan:`${baseURL}/pricing-plans/get-pricing-plans`,
    getTransaction: `${baseURL}/transactions`,
    trackPackage: `${baseURL}/track/`,
    dashboard: `${baseURL}/reports/customer`,
    subscribe: `${baseURL}/subscribe`,
    forgotPassword: `${baseURL}/password/forgot`,
    resetPassword: `${baseURL}/password/reset`,
    saveAddress: `${baseURL}/addresses`,
    cancelOrder: `${baseURL}/transaction-requests/cancel`
}